/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC, ReactElement, useContext } from 'react';
import { CompetitionsContext } from '../../context/context';
import { trans } from '../../helpers/helperFunctions';
import DropdownItem from './dropdownItem';

const Dropdown: FC = (): ReactElement => {
  const {
    selectedCompetition,
    competitions,
    setSelectedCompetition,
    matchDay,
    setMatchDay,
    dropdownToggleUseEffect,
    setDropdownToggleUseEffect
  } = useContext(CompetitionsContext);
  const matchDaysCount = Number(selectedCompetition.currentMatchday || 0);
  const matchDays: string[] = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < matchDaysCount; i++) {
    matchDays.push(`${i + 1}. ${trans('matchDay')}`);
  }

  const selectCompetitionItem = (index: number) => {
    setDropdownToggleUseEffect(!dropdownToggleUseEffect);
    setSelectedCompetition(competitions[index]);
    setMatchDay(Number(competitions[index].currentMatchday));
  };

  const selectMatchDayItem = (index: number) => {
    setDropdownToggleUseEffect(!dropdownToggleUseEffect);
    setMatchDay(matchDays.length - index);
  };

  return (
    <>
      <DropdownItem
        data={competitions.map((comp) => comp.competitionName)}
        handleSelectItem={selectCompetitionItem}
        selectedItemName={selectedCompetition?.competitionName}
      />
      {!!matchDays.length && (
        <DropdownItem
          data={[...matchDays].reverse()}
          handleSelectItem={selectMatchDayItem}
          selectedItemName={matchDays[Number(matchDay) - 1]}
        />
      )}
    </>
  );
};

export default Dropdown;
